import { computed, ComputedRef } from 'vue-demi';
import ad from './../../../store/modules/ads_creative/index';
import { CampaignObjectiveType } from '@ad/tt_ads_common_enums';
const useObjectiveHooks = (): Record<string, ComputedRef> => {
  const currentObjectiveType = computed(() => ad.getters.campaignFormData.value.objectiveType);
  const isTraffic: ComputedRef<boolean> = computed(
    () => ad.getters.campaignFormData.value.objectiveType === CampaignObjectiveType.TRAFFIC,
  );
  const isEngagement: ComputedRef<boolean> = computed(
    () => ad.getters.campaignFormData.value.objectiveType === CampaignObjectiveType.ENGAGEMENT,
  );
  const isLead: ComputedRef<boolean> = computed(
    () => ad.getters.campaignFormData.value.objectiveType === CampaignObjectiveType.LEADADS,
  );
  const isReach: ComputedRef<boolean> = computed(
    () => ad.getters.campaignFormData.value.objectiveType === CampaignObjectiveType.REACH,
  );
  const isVideoView: ComputedRef<boolean> = computed(
    () => ad.getters.campaignFormData.value.objectiveType === CampaignObjectiveType.VIDEOVIEW,
  );
  const isInvalidObjectiveForCreation: ComputedRef<boolean> = computed(
    () => !isEngagement.value && !isLead.value && !isTraffic.value && !isReach.value && !isVideoView.value,
  );
  return {
    isLead,
    isTraffic,
    isEngagement,
    currentObjectiveType,
    isInvalidObjectiveForCreation,
    isReach,
    isVideoView,
  };
};
export { useObjectiveHooks };
